var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WorkingAreaQuickView',{attrs:{"title-key":_vm.titleKey,"subtitle":_vm.subtitle,"items":_vm.items,"empty-text":_vm.emptyText || _vm.$t('no_rooms_found')},on:{"close":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }